import { render, staticRenderFns } from "./SalaryEffectEdit.vue?vue&type=template&id=20542e50&scoped=true&"
import script from "./SalaryEffectEdit.vue?vue&type=script&lang=js&"
export * from "./SalaryEffectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20542e50",
  null
  
)

export default component.exports